import { useQuery } from 'react-query';

//APP
import { api } from '../../../api';
import { localConfig } from '../../../../Configs/localConfig';
import { errorAlert } from '../../../../utils/alert';

//=================================================================================>
// BUSCAR LISTA DE PEDIDOS DO LABORATORIO PARA O BOOK DE FERTILIDADE RESUMIDO
//<=================================================================================

//TYPES
type Item__Analises = {
    profundidade: string,
    cod_profundidade: number,
    id: string,
    pontos: {INDICE: number, NOME: number, LATITUDE: number, LONGITUDE: number, VALOR: number}[],
    cod_analises: {cod: number, nome: string, valor: string}[]
}
type Item__Propriedade = {
    cod: number,
    nome: string,
    status: number,
    cod_tipo: number,
    cod_conta: number,
    cod_cliente: number,
    arquivo: null,
    area: string,
    matricula: string,
    cod_cidade: number,
    ccir: number | string,
    itr: number | string,
    nirf: number | string,
    inscricao_estadual: number | string,
    area_matricula: number | string,
    cod_calcario: number,
    cod_consultor: number,
}
type Item__Responsaveis = {
    cod: number,
    cod_pedido: number,
    cod_responsavel: number,
    responsavel_nome: string,
}
export type PedidoLaboratorio__Item = {
    cod: number,
    cod_laboratorio: number,
    cod_usuario: number,
    data: string,
    malha_de_pontos: {type: string, fileName: string, features: any[]},
    cod_area_amostra: number,
    talhao_area: string,
    talhao_arquivo:  string,
    talhao_nome:  string,
    talhao_kml: {nome: string, lookAt: { latitude: number, longitude: number }, coordenadas: { latitude: number, longitude: number }[] },
    cod_safra: number,
    cod_propriedade: number,
    status: number,
    cod_safra_conta: number,
    cod_representante: number,
    observacao: string,
    arquivo: string,
    solicitante: string,
    arquivo_processado: string,
    cod_usuario_laboratorio: number,
    parametros_resultado_cod: number,
    resultado_inconsistente: number,
    malha_de_pontos_anterior: {type: string, fileName: string, features: any[]},
    data_liberada: string,
    data_coleta: string,
    observacao_processar: string,
    data_analise: string,
    data_processamento: string,
    produtividade_prevista_principal: string,
    produtividade_prevista_secundaria: string,
    cultura_principal: string,
    cultura_secundaria: string,
    tempo_previsto: string | number,
    cod_calcario: number,
    calcario_ca_o: string,
    calcario_mg_o: string,
    calcario_peneira_fundo: string,
    hash_reprocessar: string,
    cod_replica: number,
    cod_analise: number,
    cod_conta: number,
    cod_cliente: number,
    propriedade_nome: string,
    calcario_propriedade: string,
    laboratorio_nome: string,
    safra_nome: string,
    conta_nome: string,
    cliente_nome: string,
    calcario_nome: string,
    cod_calcario_propriedade: number,
    responsaveis: Item__Responsaveis[],
    propriedade: Item__Propriedade[],
    arquivo_url: string,
    arquivo_processado_url: string,
    analises: Item__Analises[],
    representante: any[],
    cliente: { cod: number, nome: string }
}

//INTERFACE
interface PedidoLaboratorio {
    itens: PedidoLaboratorio__Item[]
}

export const useGetPedidoLaboratorio = (cod?: number) => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`pedido-laboratorio_${conta}_${codCliente}_${codSafra}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<PedidoLaboratorio, Error>(queryKey, async () => {
        return api.get(`pedido-laboratorio?codConta=${conta}&codCliente=${codCliente}&codSafra=${codSafra}&pagination=-1`)
            .then((response):any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter pedidos do laboratório');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 300000
        }
    );

    return { 
        data_pedidos: data?.itens ?? [], 
        carregando_pedidos: isFetching, 
        refetch_pedidos: refetch,
        isFetched_pedidos: isFetchedAfterMount,
        isError_pedidos: isError
    };
};



//=================================================================================>
// BUSCAR LISTA DE ANÁLISES DA PROPRIEDADE E SAFRA SELECIONADA
//<=================================================================================

//TYPES
export type ResultadoAnaliseOS__Item = {
    cod_pedido?: number,
    cod_elemento_pedido: number,
    valor: string,
    valor_distribuido: string,
    qualidade: string,
    ponto: number,
    longitude: string,
    latitude: string,
    observacao: string,
    classificacao: string,
    valor_interpretado: string | number,
    cod_propriedade: number,
    cod_safra_conta: number,
    elemento: string,
    cod_elemento: number,
    profundidade: string,
    minimo: string,
    maximo: string,
    limite_minimo: string,
    limite_maximo: string,
    media: string,
    unidade: string,
    uso_mapa: boolean,
    elemento_descricao: string,
    cod_profundidade: number,
    ordem?: number
}

//INTERFACE
interface ResultadoAnaliseOS {
    itens: ResultadoAnaliseOS__Item[]
}

export const useGetResultadoAnaliseOS = (cod_propriedade: number) => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`ap-resultado-analise-os_${conta}_${codCliente}_${codSafra}_${cod_propriedade}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<ResultadoAnaliseOS, Error>(queryKey, async () => {
        return api.get(`ap-resultado-analise-os?codConta=${conta}&codCliente=${codCliente}&codSafra=${codSafra}&codPropriedade=${cod_propriedade}&elementoUsoMapa=true&pagination=-1`)
            .then((response):any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter resultados da analise da OS');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 1500000
        }
    );

    return { 
        data_resultado: data?.itens ?? [], 
        carregando_resultado: isFetching, 
        refetch_resultado: refetch,
        isFetched_resultado: isFetchedAfterMount,
        isError_resultado: isError
    };
};